<div class="d-flex align-items-center">
  <div class="flex-grow-1 d-flex align-items-center score-bar-container">
    @if (total) {
      @for (config of barConfigs; track config.color) {
        @if (config.value) {
          @let isClickable = config.clickable || clickable && config.clickable !== false;
          <div class="score-bar"
               [ngClass]="{'clickable': isClickable}"
               [ngStyle]="{
                 '--score-bar-color': config.color,
                 '--score-bar-width': ((config.value / total) * 100) + '%'
               }"
               [ngbTooltip]="config.tooltip ? (config.tooltip | messageTranslate) : null"
               [disableTooltip]="!config.tooltip"
               (click)="isClickable && onBarClick(config.id)">
            @if (config.routerLinkConfig) {
              <a class="d-block w-100 h-100" [routerLink]="config.routerLinkConfig.route" [queryParams]="config.routerLinkConfig.queryParams"></a>
            }
          </div>
        }
      }
    } @else {
      <div class="score-bar no-value"></div>
    }
  </div>
  @if (showScore && score != null) {
    <div class="flex-shrink-0 text-body-secondary text-end score">{{score | percent: SCORE_PERCENT_FORMAT}}</div>
  }
</div>